export default {
	plans: {
		title: "Plans & Pricing",
		subtitle: "Choose the ideal plan for your temple",
		perMonth: "/month",
		freeTrial: "30 days free trial",
		getStarted: "Get Started",
		empty: "Plans coming soon",
		emptyDesc: "We're preparing our plans. Check back soon!",
		backToStart: "Back to start",
	},
	builder: {
		foundation: "Foundation",
		addons: "Add-ons",
		yourPlan: "Your plan",
		includedAlways: "Always included",
		unlimitedChain: "Unlimited members, everything included",
		notInclude: "Don't include",
		total: "Total",
		subscribeNow: "Subscribe now",
		editPlan: "Edit plan",
		editPlanTitle: "Build your plan",
		editDone: "Done",
		preselectionUnavailable: "The plan or add-on you previously chose is no longer available. Review the selection below before confirming.",
		startFree: "Try 30 days free",
		trialNote: "Add-ons aren't part of the free trial — subscribe to activate them from day one.",
		trialConfirm: {
			title: "30-day free trial",
			message:
				"During the free trial you get the plan's features, but add-ons (WhatsApp, Mercado Pago) aren't included. To use them, subscribe to a plan.",
			withAddons:
				"The add-ons you selected ({addons}) aren't part of the free trial. Subscribe to activate them from day one.",
			subscribeInstead: "Subscribe to a plan",
			continueTrial: "Continue with free trial",
		},
		optional: "optional",
		needMore: "Need more? Get in touch!",
		needMoreSubject: "I need a custom plan",
		group: {
			whatsapp: "WhatsApp alerts",
			mercadoPago: "Mercado Pago integration",
		},
	},
	trial: {
		banner: "Trial period: {days} days left",
	},
	voucher: {
		label: "Voucher code",
		placeholder: "E.g.: ORI2026",
		apply: "Apply",
		valid: "Voucher applied successfully!",
		invalid: "Invalid voucher",
		applied: "Voucher discount",
		activated: "Subscription activated successfully!",
	},
	dialog: {
		title: "Choose your plan",
		subtitle: "Select a plan to subscribe",
		confirm: "Continue",
		cancel: "Cancel",
	},
	return: {
		checkingTitle: "Confirming your payment...",
		checkingDesc: "This only takes a few seconds.",
		successTitle: "Thank you for your purchase!",
		successDesc: "Your subscription is now active.",
		successDescPlan: "Your {plan} subscription is now active.",
		pendingTitle: "We're confirming your payment",
		pendingDesc: "Confirmation may take a few minutes. If the payment went through, your plan will be activated automatically. If it wasn't completed or was declined, you can try again on the plan page.",
		viewMyPlan: "View my plan",
		goToDashboard: "Go to dashboard",
	},
	blocked: {
		ownerTitle: "Your subscription has expired",
		ownerDesc: "The trial period has ended or payment was not confirmed. Subscribe to a plan to continue using ORI.",
		memberTitle: "Access suspended",
		memberDesc: "Access to the system is temporarily suspended. Contact the temple owner to regularize the subscription.",
		currentTemple: "Current temple:",
		otherTemples: "Or switch to another temple in your account:",
		pendingCheckout: "You started subscribing to a plan but did not complete the payment:",
		resumeCheckout: "Resume where I left off",
		chooseAnother: "Choose another plan",
		logout: "Logout",
	},
	page: {
		title: "My Plan",
		plan: "Plan",
		trialExpiresIn: "Trial expires in",
		daysLeft: "({days} days left)",
		nextPayment: "Next payment",
		accessUntil: "Access until",
		subscribeNow: "Subscribe Now",
		cancelSubscription: "Cancel Subscription",
		changePlan: "Change plan",
		paymentHistory: "Payment History",
		noPayments: "No payments",
		noPaymentsDesc: "Your payment history will appear here.",
		headerAmount: "Amount",
		headerStatus: "Status",
		headerPaidAt: "Paid at",
		headerPeriod: "Period",
		cancelTitle: "Cancel Subscription",
		cancelConfirm: "Are you sure you want to cancel your subscription? Access will be maintained until the end of the current period.",
		cancelNo: "No",
		cancelYes: "Yes, cancel",
		cancelSuccess: "Subscription cancelled. Access maintained until the end of the period.",
		errorSubscribe: "Error starting subscription",
		errorCancel: "Error cancelling subscription",
		errorLoad: "Error loading plan data",
		voucher: {
			comped: "Complimentary",
			compedUntil: "Complimentary until {date}",
			discountPercent: "{value}% discount",
			discountAmount: "R$ {value} discount",
			payFullPrice: "Pay full price",
			payFullPriceConfirm: "Starting with the next invoice, Mercado Pago charges the plan's full price.",
			back: "Back",
			payFullPriceSuccess: "Discount ended.",
			payFullPriceError: "Error ending the discount",
		},
		status: {
			TRIALING: "Trial Period",
			ACTIVE: "Active",
			PAST_DUE: "Payment Pending",
			SUSPENDED: "Suspended",
			CANCELLED: "Cancelled",
			NO_SUBSCRIPTION: "No Subscription",
		},
		statusDesc: {
			TRIALING: "You are in the free trial period.",
			ACTIVE: "Your subscription is active and up to date.",
			PAST_DUE: "Your last payment failed. Please update to maintain access.",
			SUSPENDED: "Access suspended. Subscribe to reactivate.",
			CANCELLED: "Subscription cancelled. Access remains until the end of the current period.",
			CANCELLED_EXPIRED: "Subscription cancelled and period ended. Subscribe to use ORI again.",
			NO_SUBSCRIPTION: "Subscribe to start using ORI.",
		},
		paymentStatus: {
			PAID: "Paid",
			PENDING: "Pending",
			FAILED: "Failed",
			REFUNDED: "Refunded",
		},
	},
	usage: {
		title: "Plan usage",
		unlimited: "unlimited",
		estimate: "The message count is an estimate and varies with the features you enable.",
		limitKey: {
			corrente: "Active members",
			whatsappMsgMonth: "WhatsApp messages/month",
		},
	},
	upgrade: {
		title: "Plan limit reached",
		cta: "View plans",
		defaultMessage:
			"This feature is not included in your current plan. Upgrade to unlock it.",
	},
	changePlan: {
		title: "Change plan",
		current: "current",
		upgradeNote:
			"Upgrades take effect immediately. The prorated difference for the remaining days is added to your next invoice.",
		downgradeNote:
			"Switching to a lower plan is scheduled for the end of the current period — access continues until then.",
		confirm: "Change plan",
		upgraded: "Plan changed! Prorated R$ {amount} on your next invoice.",
		scheduled: "Change scheduled for the end of the current period.",
		changed: "Plan changed successfully.",
		error: "Error changing plan",
	},
	addons: {
		title: "Add-ons",
		subtitle: "Extra features for your plan",
		contracted: "Active",
		contract: "Add",
		change: "Switch to this tier",
		remove: "Remove",
		perMonth: "/mo",
		prorationWarning:
			"Access is granted immediately. The prorated amount for the remaining days will be added to your next invoice; following invoices come at the full price.",
		contractTitle: "Add add-on",
		activated: "Add-on activated! Prorated R$ {amount} on your next invoice.",
		activatedNoProration: "Add-on activated!",
		removeTitle: "Remove add-on",
		removeText:
			"The add-on stays active until the end of the current period and won't renew. No refund.",
		removeScheduled: "Removal scheduled for the end of the current period.",
		scheduledForEnd: "Change scheduled for the end of the current period.",
		pendingProration:
			"R$ {amount} (prorated) will be added to your next invoice.",
		hasScheduledChange:
			"You have a plan change scheduled for the end of the current period.",
		error: "Failed to change the add-on",
	},
};
